/*
 * @Description: 路由
 * @Date: 2025-07-16 15:29:41
 */
export const route = [
  {
    path: '/settlement-materials-list',
    name: 'settlement-materials-list',
    meta: {
      title: '结算材料管理'
    },
    component: () => import('../views/settlement-materials-list.vue')
  }
];
